/**
 * /key-art — campaign-scoped key-art browser. Reads the active
 * campaign id from localStorage (set when the operator picks a
 * campaign from /campaigns), then renders the CampaignKeyArt
 * component. Falls back to a "pick a campaign first" prompt when
 * no campaign is active.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';
import api from '../services/api';
import CampaignKeyArt from '../components/CampaignKeyArt';
import PageHeader from '../components/PageHeader';


export default function KeyArt() {
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [tried, setTried] = useState(false);

  useEffect(() => {
    const cid = (() => { try { return localStorage.getItem('activeCampaignId'); } catch (_e) { return null; } })();
    if (!cid) { setTried(true); return; }
    api.get(`/api/campaigns/${cid}`)
      .then((r) => { setCampaign(r.data); setTried(true); })
      .catch(() => { setCampaign(null); setTried(true); });
  }, []);

  if (!tried) {
    return <Box sx={{ p: 3 }}><CircularProgress size={20} /></Box>;
  }
  if (!campaign) {
    return (
      <Box sx={{ p: { xs: 1.5, md: 3 } }}>
        <PageHeader title="Key Art" subtitle="Marketing assets for the active campaign." />
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary" sx={{ mb: 1 }}>
            Pick a campaign first — key art is per-film.
          </Typography>
          <Button variant="contained" size="small" onClick={() => navigate('/campaigns')}>
            Go to Campaigns
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 1.5, md: 3 } }}>
      <PageHeader
        title={`Key Art · ${campaign.name}`}
        subtitle="Posters, banners, stills, press kits, and layered source files. Travels with the film as part of the theater package."
      />
      <CampaignKeyArt campaignId={campaign.id} />
    </Box>
  );
}
